import React, { Children } from 'react'
import { EuiFilePicker } from "@elastic/eui"

export const AdjuntarComponent = (props) =>{

    const {multiple,onChange} = props

    return(
        <EuiFilePicker
            disabled={false}
            fullWidth
            id="adjuntospicker"
            multiple={multiple}
            initialPromptText="Selecciona o arrastra los archivos a adjuntar"
            onChange={onChange}
            {...props}
        />
    )
}